import React, { useState, useEffect, useRef } from "react";
import Modal from "./Modal";

import "./Modal.css";
import axios from "axios";
import { encryptString, createSession } from "../../../utils/apiUtils";

import { v4 as uuidv4 } from "uuid";

export const AbhaSendOtp = ({
  showAbhaSendOtp,
  closeSendOtpModal,
  setshowAbhaVerifyOtp,
  setshowAbhaSendOtp,
  setAbhaTxnId,
}) => {

  const [displayValue, setDisplayValue] = useState("");
  const [adharno, setadharno] = useState("");
  const [accessToken, setaccessToken] = useState("");
  const [adharEncrpt, setadharEncrpt] = useState("");
  const [errorMessage, seterrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const consentCheckboxRef = useRef(null);
  const [user, setUser] = useState(null);


  useEffect(() => {
    const userData = localStorage.getItem("loggedinUserdetails") || localStorage.getItem("NIKSHAY_loggedinUserdetails");
    if (userData) {
      try {
        setUser(JSON.parse(userData));
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  const handleInputChange = (e) => {
    const inputValue = e.target.value;

    // Remove non-numeric characters
    const numericValue = inputValue.replace(/\D/g, "");

    // Format the value as xx-xxxx-xxxx-xxxx
    const formattedValue = numericValue.replace(
      /^(\d{0,4})(\d{0,4})(\d{0,4}).*/,
      (match, p1, p2, p3, p4) => [p1, p2, p3, p4].filter(Boolean).join("-")
    );

    // Update state
    setDisplayValue(formattedValue);
    setadharno(numericValue);
  };

  const sendAbhaOtpRequest = async (encryptedAdhar) => {
    const Backend_token = localStorage.getItem("Backend_token");
    try {
      const response = await axios.post(
        "/abdm/sendOtp",
        {
          request: {
            txnId: "",
            scope: ["abha-enrol"],
            loginHint: "aadhaar",
            loginId: encryptedAdhar,
            otpSystem: "aadhaar",
          },
          header: {
            "Content-Type": "application/json",
            "REQUEST-ID": uuidv4(),
            TIMESTAMP: new Date().toISOString(), // Generate the current timestamp dynamically
            Authorization: `Bearer ${accessToken}`,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Backend_token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("Server responded with a status:", error.response.status);
        console.error("Response data:", error.response.data);
      } else if (error.request) {
        console.error(
          "Request was made, but no response received:",
          error.request
        );
      } else {
        console.error("Error in setting up the request:", error.message);
      }
    }
  };

  // Trigger when accessToken changes
  useEffect(() => {
    const sendOtpIfReady = async () => {
      if (accessToken && adharEncrpt) {
        const abhaOtpResponse = await sendAbhaOtpRequest(adharEncrpt);
        if (abhaOtpResponse?.txnId) {
          setAbhaTxnId(abhaOtpResponse.txnId);
          setaccessToken("");
          setadharEncrpt("");
          seterrorMessage("");
          setIsLoading(false);
          setshowAbhaSendOtp(false);
          setshowAbhaVerifyOtp(true);
        } else {
          setaccessToken("");
          setadharEncrpt("");
          setIsLoading(false);
          seterrorMessage(
            abhaOtpResponse?.message || "Failed to send OTP. Please try again."
          );
        }
      }
    };
    sendOtpIfReady();
  }, [accessToken, adharEncrpt]);

  const handleCreateAbhaOtp = async () => {
    try {
      if (consentCheckboxRef.current.checked) {
        setIsLoading(true);

        // Encrypt Aadhaar
        const encryptedAdhar = await encryptString(adharno);
        if (!encryptedAdhar) {
          setIsLoading(false);
          seterrorMessage("Failed to encrypt Aadhaar. Please try again.");
          return;
        }
        setadharEncrpt(encryptedAdhar); // Update state

        // Create session
        const sessionResponse = await createSession();
        if (!sessionResponse?.accessToken) {
          setIsLoading(false);
          seterrorMessage(
            sessionResponse?.error?.message || "Failed to create session."
          );
          return;
        }
        setaccessToken(sessionResponse.accessToken); // Update state
        localStorage.setItem("abdmAccessToken", sessionResponse.accessToken);
      } else {
        seterrorMessage("Kindly click on the consent box to proceed further.");
      }
    } catch (error) {
      setIsLoading(false);
      seterrorMessage("An unexpected error occurred. Please try again.");
      console.error(error);
    }
  };

  //   const closeSendOtpModal = () => {
  //     setshowAbhaSendOtp(false);
  //   };

  return (
    <>
      {showAbhaSendOtp && (
        <div
          className="modal fade show d-block verificationModel addPatentModel1"
          id="exampleModal"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header border-bottom-0">
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"

                  onClick={closeSendOtpModal}
                />
              </div>
              <div className="modal-body">
                <div className="row Abharow">
                  <div className="col-md-6 text-center">
                    <img src="/images/Abha.svg" alt="" className="abhaLogo" />
                    <h2>Create ABHA</h2>
                  </div>
                  <div className="col-md-6 text-left">
                    <label className="header_text">Enter Aadhaar Number:</label>
                    {errorMessage && (
                      <p className="error-message-modal">{errorMessage}</p>
                    )}
                    <input
                      type="text"
                      name="adharno"
                      placeholder="xxxx-xxxx-xxxx"
                      className="form-control"
                      maxLength="14"
                      value={displayValue}
                      onChange={handleInputChange}
                      autoComplete="off"
                    />
                    <div className="modal-buttonss">
                      <button
                        className="btn btn btn-primary btn-prim border-0"
                        style={{
                          backgroundColor:
                            adharno.length === 12 ? "#3FC4F4" : "#A9A9A9", // Green when valid, Gray otherwise
                          color: "white",
                          marginRight: "10px",
                        }}
                        onClick={handleCreateAbhaOtp}
                        disabled={adharno.length !== 12 || isLoading}
                      >
                        {isLoading ? "Processing.." : "Get OTP"}
                      </button>
                      <button
                        className="btn btn-secondary btn-Secon border-0"
                        style={{
                          backgroundColor:
                            adharno.length === 12 ? "#F9A023" : "#A9A9A9", // Red when valid, Blue otherwise
                          color: "white",
                        }}
                        type="reset"
                        onClick={() => (
                          setadharno(""),
                          setDisplayValue(""),
                          seterrorMessage("")
                        )}
                        disabled={adharno.length !== 12}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="row">
                  <>
                    <div className="col-md-12 text-left">
                      <label>
                        <input
                          type="checkbox"
                          name="consent-checkbox"
                          id="consent-checkbox"
                          ref={consentCheckboxRef}
                          value="1"
                        />
                        <span className="fw-bold ms-1">
                          {" "}
                          I hereby declare that:{" "}
                        </span>
                      </label>
                      <ul style={{fontSize: "15px", fontWeight: "500"}}>
                        <li>
                          I am voluntarily sharing my Aadhaar Number / Virtual
                          ID issued by the Unique Identification Authority of
                          India (“UIDAI”), and my demographic information for
                          the purpose of creating an Ayushman Bharat Health
                          Account number (“ABHA number”) and Ayushman Bharat
                          Health Account address (“ABHA Address”). I authorize
                          NHA to use my Aadhaar number / Virtual ID for
                          performing Aadhaar based authentication with UIDAI as
                          per the provisions of the Aadhaar (Targeted Delivery
                          of Financial and other Subsidies, Benefits and
                          Services) Act, 2016 for the aforesaid purpose. I
                          understand that UIDAI will share my e-KYC details, or
                          response of “Yes” with NHA upon successful
                          authentication.
                        </li>
                        <li>
                          I consent to usage of my ABHA address and ABHA number
                          for linking of my legacy (past) government health
                          records and those which will be generated during this
                          encounter.
                        </li>
                        <li>
                          I authorize the sharing of all my health records with
                          healthcare provider(s) for the purpose of providing
                          healthcare services to me during this encounter.
                        </li>
                        <li>
                          I consent to the anonymization and subsequent use of
                          my government health records for public health
                          purposes.
                        </li>
                        <li>
                          I, healthcare worker with username <b>{user?.username}</b>,
                          confirm that I have duly informed and explained the
                          beneficiary of the contents of consent for
                          aforementioned purposes.
                        </li>
                        <li>
                          I have been explained about the consent as stated
                          above and hereby provide my consent for the
                          aforementioned purposes.
                        </li>
                      </ul>
                    </div>
                  </>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
